"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var MIN_LENGTH = 8;
var UPPER_LOWER_RULE = /^(?=.*[a-z])(?=.*[A-Z]).+$/;
var NUMBER_RULE = /^(?=.*\d).+$/;
var SPECIAL_CHAR_RULE = /^(?=.*[-+_!@#$%^&*., ?]).+$/;
var validatePassword = function (currentPassword, password, confirmPassword, t, onBlur) {
    if (onBlur === void 0) { onBlur = false; }
    var passwordError = '';
    var confirmPasswordError = '';
    var strength = 0;
    var isMinLength = password.length >= MIN_LENGTH;
    var hasUpperAndLower = UPPER_LOWER_RULE.test(password);
    var hasNumber = NUMBER_RULE.test(password);
    var hasSpecialChar = SPECIAL_CHAR_RULE.test(password);
    if (password)
        strength += 10;
    if (isMinLength)
        strength += 10;
    if (hasUpperAndLower)
        strength += 10;
    if (hasNumber)
        strength += 10;
    if (hasSpecialChar)
        strength += 10;
    if (password.length > 12 && strength === 50)
        strength += 50;
    var meetsReqs = isMinLength && hasUpperAndLower && hasNumber && hasSpecialChar;
    var isMatch = password === confirmPassword;
    var isCurrent = currentPassword === password;
    if (password && !meetsReqs) {
        passwordError = t('prism-header:password-bad-characters', 'Password does not contain all required characters');
    }
    else if (password && isCurrent) {
        passwordError = t('prism-header:password-same-as-current', 'New password cannot be the same as your current password');
    }
    else if (onBlur && !isMatch) {
        confirmPasswordError = t('prism-header:passwords-do-not-match', 'Passwords do not match');
    }
    return {
        hasNumber: hasNumber,
        hasSpecialChar: hasSpecialChar,
        hasUpperAndLower: hasUpperAndLower,
        isMatch: isMatch,
        isMinLength: isMinLength,
        passwordError: passwordError,
        confirmPasswordError: confirmPasswordError,
        strength: strength,
    };
};
var usePasswordValidator = function (currentPassword, password, confirmPassword) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = __read((0, react_1.useState)({
        hasNumber: false,
        hasSpecialChar: false,
        hasUpperAndLower: false,
        isMatch: false,
        isMinLength: false,
        strength: 0,
        passwordError: '',
        confirmPasswordError: '',
    }), 2), state = _a[0], setState = _a[1];
    var validate = function () {
        return setState(validatePassword(currentPassword, password, confirmPassword, t, true));
    };
    (0, react_1.useEffect)(function () {
        setState(validatePassword(currentPassword, password, confirmPassword, t));
    }, [currentPassword, password, confirmPassword, setState, t]);
    return __assign(__assign({}, state), { isValid: state.isMatch &&
            state.isMinLength &&
            state.hasNumber &&
            state.hasSpecialChar &&
            state.hasUpperAndLower, actions: { validate: validate } });
};
exports.default = usePasswordValidator;
//# sourceMappingURL=usePasswordValidator.js.map